import React, { useState } from 'react';
import { Link, useNavigate, useLocation } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';
import { useCart } from '../contexts/CartContext';
import { FaShoppingCart, FaUser, FaSignOutAlt } from 'react-icons/fa';

const Navbar = () => {
  const { user, logout } = useAuth();
  const { getCartCount } = useCart();
  const navigate = useNavigate();
  const location = useLocation();
  const [menuOpen, setMenuOpen] = useState(false);

  const handleLogout = () => {
    logout();
    navigate('/');
  };

  const isActive = (path) => location.pathname === path;

  const handleMenuToggle = () => setMenuOpen((open) => !open);
  const handleNavLinkClick = () => setMenuOpen(false);

  return (
    <nav className="navbar" style={{ boxShadow: '0 2px 12px rgba(34,34,59,0.07)' }}>
      <div className="container d-flex justify-content-between align-items-center">
        <Link to="/" className="navbar-brand">
          🍽️ Food Ordering App
        </Link>
        <button
          className="navbar-toggle"
          aria-label="Toggle navigation"
          aria-expanded={menuOpen}
          onClick={handleMenuToggle}
        >
          <span className="navbar-toggle-icon">&#9776;</span>
        </button>
        <ul className={`navbar-nav d-flex align-items-center${menuOpen ? ' open' : ''}`}>
          <li>
            <Link to="/products" className={`nav-link${isActive('/products') ? ' bg-accent' : ''}`} onClick={handleNavLinkClick}>
              Menu
            </Link>
          </li>
          {user && (
            <>
              <li>
                <Link to="/orders" className={`nav-link${isActive('/orders') ? ' bg-accent' : ''}`} onClick={handleNavLinkClick}>
                  My Orders
                </Link>
              </li>
              <li>
                <Link to="/cart" className="nav-link d-flex align-items-center" onClick={handleNavLinkClick}>
                  <FaShoppingCart />
                  <span className="ms-1">({getCartCount()})</span>
                </Link>
              </li>
              <li>
                <div className="nav-link d-flex align-items-center" style={{ fontWeight: 600 }}>
                  <FaUser className="me-1" />
                  {user.name}
                </div>
              </li>
              <li>
                <button onClick={() => { handleLogout(); handleNavLinkClick(); }} className="btn btn-danger btn-sm nav-link d-flex align-items-center gap-2" style={{ marginLeft: 8 }}>
                  <FaSignOutAlt />
                  <span>Logout</span>
                </button>
              </li>
            </>
          )}
          {!user && (
            <>
              <li>
                <Link to="/login" className={`nav-link${isActive('/login') ? ' bg-accent' : ''}`} onClick={handleNavLinkClick}>
                  Login
                </Link>
              </li>
              <li>
                <Link to="/register" className={`nav-link${isActive('/register') ? ' bg-accent' : ''}`} onClick={handleNavLinkClick}>
                  Register
                </Link>
              </li>
            </>
          )}
        </ul>
      </div>
    </nav>
  );
};

export default Navbar; 